import React, { useContext, useEffect, useState } from 'react';
import { useNavigate } from 'react-router-dom';
import BotaoCadastro from '../../../Componentes/BotaoCadastro';
import CorpoPagina from '../../../Componentes/CorpoPagina';
import ModalConfirmacao from '../../../Componentes/ModalConfirmacao';
import ModalView, { ModalTópico } from '../../../Componentes/ModalView';

import { FixedInput } from '../../../Componentes/TextInput';
import { StoreContexto } from '../../../Contexto/Provider';
import { apiService } from '../../../Services/ApiService';
import TabelaComponente from '../../../Componentes/TabelaComponente';
import PesquisaInput from '../../../Componentes/PesquisaInput';
import useDebounce from '../../../Hooks/debouceSearch';
import TopicoTexto from '../../../Componentes/TopicoTexto';
import '../../../Estilos/EstiloBotao.css';
import useWindowSize from '../../../Hooks/windowSize';

export default function AtuadoresLista() {
  const windowSize = useWindowSize();
  const [isMobile, setIsMobile] = useState(false);

  const { auth } = useContext(StoreContexto);
  const { get, del } = apiService();
  const [actuators, setActuators] = useState([]);
  const [totalActuators, setTotalActuators] = useState(0);
  const [page, setPage] = useState(0);
  const [isLoading, setIsLoading] = useState(true);
  const [menuOptions, setMenuOptions] = useState(['Visualizar', 'Excluir']);
  const [actuator, setActuator] = useState({});
  const [searchText, setSearchText] = useState('');
  const debounceSearch = useDebounce(searchText, 500);
  const navigate = useNavigate();
  const [modalVisible, setModalVisible] = useState(false);
  const [modalConfirm, setModalConfirm] = useState({
    visible: false,
    message: '',
    operation: '',
    id: '',
  });
  const [modalError, setModalError] = useState({
    visible: false,
    message: '',
  });

  useEffect(() => {
    if (auth.perfilSalvo === 'OWNER') {
      setMenuOptions(['Visualizar', 'Excluir']);
    }
  }, [auth]);

  useEffect(() => {
    setIsMobile(windowSize.width < 768);
  }, [windowSize]);

  useEffect(() => {
    getActuators();
  }, [page]);

  useEffect(() => {
    getActuators(debounceSearch);
  }, [debounceSearch]);

  const getActuators = async (currentSearchText = '') => {
    const queryParams = { page, size: 10, search: currentSearchText };
    setIsLoading(true);
    try {
      const data = await get('actuators', queryParams);
      if (data) {
        setActuators(data.result || []);
        setTotalActuators(data.total || 0);
      }
    } catch (error) {
      setModalError({ visible: true, message: 'Erro ao buscar atuadores' });
    } finally {
      setIsLoading(false);
    }
  };

  const getActuatorById = async (actuatorId) => {
    setIsLoading(true);
    try {
      const actuator = await get(`actuators/${actuatorId}`);
      setActuator(actuator);
    } catch (error) {
      setModalError({ visible: true, message: 'Erro ao buscar atuador' });
    } finally {
      setIsLoading(false);
    }
  };

  const deleteActuator = async (actuatorId) => {
    setIsLoading(true);
    try {
      await del(`actuators/${actuatorId}`);
      getActuators();
    } catch (error) {
      setModalError({ visible: true, message: 'Erro ao realizar operação' });
    } finally {
      setIsLoading(false);
    }
  };

  const handleSearch = (text) => {
    setSearchText(text);
  };

  const handleEditClick = (actuatorId) => {
    navigate(`/actuator-form/${actuatorId}`);
  };

  const handleMenuItemSelect = (actuatorId, menuItem) => {
    switch (menuItem) {
      case 'Visualizar':
        getActuatorById(actuatorId).then(() => setModalVisible(true));
        break;
      case 'Excluir':
        setModalConfirm({
          visible: true,
          message: 'Deseja realmente excluir este atuador?',
          operation: 'Excluir',
          id: actuatorId,
        });
        break;
      default:
        break;
    }
  };

  const nextPage = async () => {
    setPage(page + 1);
  };

  const previousPage = async () => {
    setPage(page - 1);
  };

  /**/
  return (
    <CorpoPagina loading={isLoading}>
      {modalError.visible && (
        <ModalConfirmacao
          aviso={modalError.message}
          erro={true}
          clicado={() => setModalError({ visible: false, message: '' })}
        />
      )}

      {modalConfirm.visible && (
        <ModalConfirmacao
          aviso={modalConfirm.message}
          confirmar={false}
          clicado={() => {
            deleteActuator(modalConfirm.id);
            setModalConfirm({ visible: false, message: '', operation: '', id: '' });
          }}
          clicadoVolta={() =>
            setModalConfirm({ visible: false, message: '', operation: '', id: '' })
          }
        />
      )}

      {modalVisible ? (
        <ModalView height={508} width={isMobile ? 270 : 450}>
          <ModalTópico titulo="Visualizar Atuador" />
          <div style={{ width: '100%', display: 'flex', justifyContent: 'center' }}>
            <div
              style={{
                width: '85%',
                display: 'flex',
                flexDirection: 'row',
                justifyContent: 'space-between',
                alignItems: 'flex-start',
                marginTop: 36,
              }}
            >
              <div
                style={{
                  display: 'flex',
                  width: '100%',
                  flexDirection: 'column',
                  padding: 0,
                  margin: 0,
                }}
              >
                {/* <ModalTópicoView titulo="DADOS GERAIS" /> */}
                <FixedInput
                  titulo="Nome"
                  padrao={actuator.name}
                  tipo="text"
                  largura="90%"
                  disabled={true}
                />
                <FixedInput
                  titulo="ID"
                  padrao={actuator.identifier}
                  tipo="text"
                  largura="90%"
                  disabled={true}
                />
                <FixedInput
                  titulo="Localização"
                  padrao={actuator.environment.name}
                  tipo="text"
                  largura="90%"
                  disabled={true}
                />
              </div>
            </div>
          </div>

          <button id="BotaoCadastro" style={{ margin: 30 }} onClick={() => setModalVisible(false)}>
            Fechar
          </button>
        </ModalView>
      ) : null}

      <div className="ContainerGeral">
        <TopicoTexto titulo="Lista de Atuadores" altura={50} />
        <BotaoCadastro
          visivel={auth.perfilSalvo === 'OWNER'}
          nome="Cadastrar"
          clicado={() => {
            navigate('/actuator-form');
          }}
        />
        <PesquisaInput placeholder="Insira o nome do atuador" onSearch={handleSearch} />
        <TabelaComponente
          colunas={isMobile ? ['NOME'] : ['NOME', 'AMBIENTE', 'ID']}
          campos={isMobile ? ['name'] : ['name', 'environment.name', 'identifier']}
          linhas={actuators}
          paginaAtual={page}
          total={totalActuators}
          aviso={!actuators.length ? 'Não há atuadores cadastrados' : 'Buscando atuadores...'}
          menuOptions={menuOptions}
          onEditClick={handleEditClick}
          onMenuItemSelect={handleMenuItemSelect}
          goToNextPage={() => nextPage()}
          goToPreviousPage={() => previousPage()}
          entity={'actuator'}
          role={auth.perfilSalvo}
        />
      </div>
    </CorpoPagina>
  );
}
